import { WebinarInfo } from "@/models/WebinarInfo"
import IFullVideoData, { FullVideoData } from "@/models/FullVideoData"
import { WebinarDataService } from "@/services/WebinarDataServices"
import { container } from "tsyringe"
import { SingleVideoInfo } from "@/models/SingleVideoInfo"
import mergeSubtitles from "@/services/mergeSubtitles"
export function getFullVideo(
  webinatInfo: WebinarInfo
): Promise<IFullVideoData> {
  if (webinatInfo.video_urls)
    return Promise.resolve(
      new FullVideoData(
        webinatInfo.video_urls,
        mergeSubtitles(webinatInfo.subtitle_urls, webinatInfo.subtitles)
      )
    )
  if (webinatInfo.uniqueness) getFullVideoByCall(webinatInfo.uniqueness)
  return Promise.resolve(new FullVideoData(undefined, undefined))
}
export function getFullVideoByCall(
  alternateId: string
): Promise<IFullVideoData> {
  if (alternateId == undefined)
    return Promise.resolve(new FullVideoData(undefined, undefined))
  const _dataService = container.resolve(WebinarDataService)
  return _dataService.getData(`v${alternateId}`).then(returnValue => {
    if (returnValue == undefined) return new FullVideoData(undefined, undefined)
    const videoInfo = returnValue as SingleVideoInfo
    return new FullVideoData(
      videoInfo.video_urls,
      mergeSubtitles(videoInfo.subtitle_urls, videoInfo.subtitles)
    )
  })
}
